export const LEAGUE_ID = "1380999967312736256";
export const LEAGUE_IDS = {
  2023: "999341031889952768",
  2024: "1049462983430840320",
  2025: "1248116529610883072",
  2026: "1380999967312736256",
};

export const DYNASTIES = [
  {
    iteration: 1,
    name: "Dynasty I",
    season_start: 2023,
    season_end: null,
    season_wins_needed: 3,
    winner: null,
  },
];

export const SEASONS = [2026, 2025, 2024, 2023];

export const DRAFT_IDS = {
  2025: "1248116529619275776",
  2026: "1380999967329488896",
};

export const POSITIONS = {
  QB: "Quarterback",
  RB: "Running Back",
  WR: "Wide Receiver",
  TE: "Tight End",
  K: "Kicker",
  DEF: "Defense",
  DST: "Defense/Special Teams",
  OL: "Offensive Lineman",
  DL: "Defensive Lineman",
  LB: "Linebacker",
  DB: "Defensive Back",
  HC: "Head Coach",
  P: "Punter",
  LS: "Long Snapper",
};

export const IS_LEAGUE_ACTIVE = true;

export const HYPERLINK = {
  drive:
    "https://drive.google.com/drive/folders/1b8rxyCXi_al_9z5Wp39z8va5iE7OlB8h?usp=drive_link",
  sleeper: `https://sleeper.com/leagues/${LEAGUE_ID}`,
};
